import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import {  Link, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getContact } from '../Store/ActionCreators/ContactActionCreator'

export default function UserProfiile() {
    const [data, setData] = useState('')
        const stdProfile = useSelector((state) => state.UserStateData)
        const { _id } = useParams()
        const dispatch = useDispatch()
    
        useEffect(() => {
         dispatch(getContact());
    }, [dispatch]);

    useEffect(() => {
    if (stdProfile?.length > 0 && _id) {
        const student = stdProfile.find(
        (item) => item._id === (_id)
        );
        if (student) {
        setData(student);
        }
    }
    }, [stdProfile, _id]);
    return (
    <>
        <Box sx={{ display: "flex" ,width:"100%" }}>
            <Sidebar/>
            <Box className="boxStyle mt-4 w-100 mx-3">
                <h4 className='mt-5 bg-primary text-light text-center  rounded p-1'>User Profile</h4>
                <div className="row mx-3 mb-3 mt-5">
                    <div className="col-md-6">
                        <div className="card d-flex" style={{border:"1px solid black",padding:"10px"}}>
                          <p><b>Name:</b></p> <p>{data.name}</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card d-flex" style={{border:"1px solid black",padding:"10px"}}>
                          <p><b>Mobile Number:</b></p> <p>{data.mobile}</p>
                        </div>
                    </div>
                </div>
                 <div className="row mx-3 mb-3">
                    <div className="col-md-6">
                        <div className="card d-flex" style={{border:"1px solid black",padding:"10px"}}>
                          <p><b>Email:</b></p> <p>{data.email}</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card d-flex" style={{border:"1px solid black",padding:"10px"}}>
                          <p><b>Role:</b></p> <p>{data.role}</p>
                        </div>
                    </div>
                </div>
                 <div className="row mx-3 mb-5">
                    <div className="col-md-6">
                        <div className="card d-flex" style={{border:"1px solid black",padding:"10px"}}>
                          <p><b>Status:</b></p> <p>{data.status}</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card d-flex" style={{border:"1px solid black",padding:"10px"}}>
                          <p><b>Admin ID:</b></p> <p>{data._id}</p>
                        </div>
                    </div>
                </div>
                <p className='mx-5 bg-primary p-2 rounded text-center '><Link to="/userpage" style={{textDecoration:"none",color:"#fff"}}>Go To User Panel</Link></p>
            </Box>
        </Box>
    </>
  )
}
